import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import LoginComponentVue from '@/components/LoginComponent.vue'
import AdminComponentVue from "@/components/AdminComponent.vue"
import UserComponentVue from "@/components/UserComponent.vue"
import StartTestComponentVue from "@/components/StartTestComponent.vue"
import TestQuestionsComponentVue from "@/components/TestQuestionsComponent.vue"


function isAuthentificated(): boolean {
  // eslint-disable-next-line
  //@ts-ignore
  if (JSON.parse(localStorage.getItem("piniaState")) === null) {
    return true;
  } else {
    // eslint-disable-next-line
    //@ts-ignore
    return JSON.parse(localStorage.getItem("piniaState")).auth.token === "" || JSON.parse(localStorage.getItem("piniaState")).auth.token === null
  }
}

function getRoles(): { admin: boolean, user: boolean } {
  // eslint-disable-next-line
  //@ts-ignore
  return JSON.parse(localStorage.getItem("piniaState")).auth.roles
}

const routes: Array<RouteRecordRaw> = [
  {
    path: "/:catchAll(.*)",
    redirect: to => {
      if (localStorage.getItem("piniaState") !== null) {
        if (isAuthentificated()) {
          return { name: "login" }
        }
      }
      return { name: "admin" }
    },
  },
  {
    path: '/',
    name: 'login',
    component: LoginComponentVue
  },
  {
    path: "/admin",
    name: "admin",
    component: AdminComponentVue
  },
  {
    path: "/user",
    name: "user",
    component: UserComponentVue
  },
  {
    path: "/start",
    name: "start",
    component: StartTestComponentVue
  },
  {
    path: "/test",
    name: "test",
    component: TestQuestionsComponentVue
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  if (to.name === "login") {
    next();
  } else if (!isAuthentificated()) {
    if (to.name === "admin" && getRoles().admin === false && getRoles().user === true) {
      next("/user")
    } else if (to.name !== "admin" && getRoles().user === false && getRoles().admin === true) {
      next("/admin")
    } else if (getRoles().user === false && getRoles().admin === false) {
      next("/login")
    } else {
      next();
    }
  } else {
    next();
  }
})

export default router
